import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Form } from 'reactstrap';
import Navigation from '../../../components/Navigation/Navigation';
import ContactFields from '../../../components/Fields/ContactFields';
import FormValidator from '../../../utils/FormValidator';
import { ValidateAccountPassword, ValidateEmailAddress, ValidatePhoneNumber, ValidatePhoneNumberOptional } from '../../../utils/Validation';
import withBackgroundImage from '../../../HOC/withBackgroundImage';
import debounce from 'debounce';

import { updateContact } from '../../../actions/personalInfoAction';

class Contact extends Component {
  constructor(props) {
    super(props);

    this.validator = new FormValidator([
      // PBI 441341 VOA: Replace the drop-down for the Primary and Authorized User Phone fields with two separate input fields for Mobile and Home phone numbers
      { 
        field: 'mobilePhone', 
        method: 'isEmpty', 
        validWhen: false, 
        message: 'Oops, mobile phone is required.' 
      }, 
      { 
        field: 'mobilePhone', 
        method: ValidatePhoneNumber, 
        validWhen: true, 
        message: 'Oops, mobile phone number is not valid.' 
      },
      { 
        field: 'homePhone', 
        method: ValidatePhoneNumberOptional, 
        validWhen: true, 
        message: 'Oops, home phone number is not valid.' 
      }, 
      { 
        field: 'email', 
        method: ValidateEmailAddress, 
        validWhen: true, 
        message:  'Oops, email doesn’t look right.' 
      },
      // PBI 441340 VOA: Set 'Email' as a required field and add it to the Authorized User form
      { 
        field: 'email', 
        method: 'isEmpty', 
        validWhen: false, 
        message: 'Oops, email is required.' 
      },   
      { 
        field: 'email', 
        method: 'isLength', 
        args: [{min:0, max: 50}],
        validWhen: true, 
        message: 'Oops, email is too long, Please shorten to 50 characters.' 
      },    
      { 
        field: 'accountPassword', 
        method: 'isEmpty', 
        validWhen: false, 
        message: 'Oops, verification password is required.' 
      },
      { 
        field: 'accountPassword', 
        method: ValidateAccountPassword, 
        validWhen: true, 
        message:  'Oops, verification password doesn’t look right.' 
      },  
      { 
        field: 'accountPassword', 
        method: 'isLength', 
        args: [{min:0, max: 15}],
        validWhen: true, 
        message: 'Oops, verification password is too long, Please shorten to 15 characters.' 
      },
    ]);    

    this.state = {
      email: this.props.email || "",
      mobilePhone: this.props.mobilePhone || "",
      homePhone: this.props.homePhone || "",
      accountPassword: this.props.accountPassword || "",
      validation: this.validator.valid()
    };

    this.onClickForward = this.onClickForward.bind(this);
    this.onClickBackward = this.onClickBackward.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.validateField = this.validateField.bind(this);
  }
  onClickForward(event) {
    event.preventDefault();
    this.setState({validation: this.validator.validate(this.state)}, () => {
      if(this.state.validation.isValid) {
        this.props.history.replace('/PersonalInfo/Address');
      }
    });
  }
  onClickBackward() {
    this.props.history.replace('/PersonalInfo/Birthdate');
  }
 
  handleChange(event) {
    this.setState({
      validation: {...this.state.validation, [event.target.name]: this.validator.resetFieldValidation(event.target.name)},
      [event.target.name]:event.target.value
    }, () => { 
      this.updateContact();
    });
  }
  // PBI 441341 VOA: Replace the drop-down for the Primary and Authorized User Phone fields with two separate input fields for Mobile and Home phone numbers
  updateContact = debounce(() => {
    this.props.updateContact(this.state.email, this.state.mobilePhone, this.state.homePhone, this.state.accountPassword);
  }, 1000);
  validateField(event) {
    this.setState({
      validation: {...this.state.validation, [event.target.name]: this.validator.validateField(event.target.name, event.target.value)}
    });
  }
  render() {
    return (
      <div>
        <h1>How can we reach you?</h1>
        <p>We may contact you if we require further information or to provide updates on the status of your application. Your privacy is important to us and we’ll keep your sensitive information secure.</p>
        <Form onSubmit={this.onClickForward}>
        {/* PBI 441341 VOA: Replace the drop-down for the Primary and Authorized User Phone fields with two separate input fields for Mobile and Home phone numbers */}
          <ContactFields handleChange={this.handleChange} validateField={this.validateField} {...this.state} />
          <Navigation onClickForward={this.onClickForward} onClickBackward={this.onClickBackward} />
        </Form>
      </div>);
  }
}

const mapStateToProps = state => ({
  ...state.personalInfo
});
// PBI 441341 VOA: Replace the drop-down for the Primary and Authorized User Phone fields with two separate input fields for Mobile and Home phone numbers
const mapDispatchToProps = dispatch => ({
  updateContact: (email, mobilePhone, homePhone, accountPassword) => dispatch(updateContact(email, mobilePhone, homePhone, accountPassword))
});

export default connect(mapStateToProps, mapDispatchToProps)(withBackgroundImage("know-you")(Contact));


// WEBPACK FOOTER //
// ./src/containers/PersonalInfo/Contact/Contact.js